export default __webpack_public_path__ + "static/quickGuideBackground-3393eb81ac263945decc981b27933948.png";